import { useCallback, useState } from "react";
import { apiJson } from "../dependencies/api.ts";
import { useMessageHandler } from "../context/MessageContext.tsx";
import { Offer } from "../models/offer.ts"

export const useOffer = () => {
  const { handle } = useMessageHandler();
  const [statusMessage, setStatusMessage] = useState<string | null>(null);

  const requestOffer = useCallback(async (data: Offer) => {
    await handle(async () => {
      setStatusMessage("");
      const response = await apiJson.post("/offer/request", data);
      if (response.data.success) {
        setStatusMessage("Anfrage erfolgreich versandt.");
      } else {
        setStatusMessage("Fehler beim Versenden der Anfrage.");
      }
    });
  }, [handle]);

  return {requestOffer, statusMessage}
};
